module.exports = __webpack_public_path__ + "img/share-white.53f3ebc7.svg";